export default "__VITE_PUBLIC_ASSET__1480fc0c__"